import { Link } from 'react-router-dom';
import logo from '../../assets/logo_nexus_sem_fundo.png';
import styles from './MinimalHeader.module.css';

/**
 * MinimalHeader — barra simples para fluxos de auth (login, registro, recuperar senha).
 * Fundo branco sólido, sem sticky, sem CTAs.
 */
export default function MinimalHeader() {
  return (
    <header className={styles.header} role="banner">
      <div className={styles.inner}>
        {/* Logo */}
        <Link to="/" className={styles.logo} aria-label="Nexus Tech — página inicial">
          <img src={logo} alt="" width="32" height="32" className={styles.logoImg} />
          <span className={styles.logoText}>Nexus Tech</span>
        </Link>

        {/* Link de volta (desktop) */}
        <a href="/" className={styles.backLink}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M19 12H5M12 5l-7 7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Voltar para o site
        </a>
      </div>
    </header>
  );
}
